// Minimal markdown to HTML renderer (no dependencies) for clinical AI output.
// Supports headings, bold, italics, code, lists, paragraphs.

function escapeHtml(s) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function renderMarkdown(md) {
  if (!md) return "";
  const lines = md.split("\n");
  const html = [];
  let inList = false;
  let listType = null;
  let inPara = false;

  const closeList = () => {
    if (inList) {
      html.push(listType === "ol" ? "</ol>" : "</ul>");
      inList = false;
      listType = null;
    }
  };
  const closePara = () => {
    if (inPara) {
      html.push("</p>");
      inPara = false;
    }
  };

  const inline = (text) => {
    let t = escapeHtml(text);
    t = t.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    t = t.replace(/\*(.+?)\*/g, "<em>$1</em>");
    t = t.replace(/`([^`]+)`/g, "<code>$1</code>");
    return t;
  };

  for (let raw of lines) {
    const line = raw.trimEnd();
    if (!line.trim()) {
      closeList();
      closePara();
      continue;
    }
    const h = line.match(/^(#{1,6})\s+(.*)$/);
    if (h) {
      closeList();
      closePara();
      const level = h[1].length;
      html.push(`<h${level}>${inline(h[2])}</h${level}>`);
      continue;
    }
    const ol = line.match(/^\s*\d+\.\s+(.*)$/);
    const ul = line.match(/^\s*[-*]\s+(.*)$/);
    if (ol || ul) {
      closePara();
      const want = ol ? "ol" : "ul";
      if (!inList || listType !== want) {
        closeList();
        html.push(want === "ol" ? "<ol>" : "<ul>");
        inList = true;
        listType = want;
      }
      html.push(`<li>${inline((ol || ul)[1])}</li>`);
      continue;
    }
    closeList();
    if (!inPara) {
      html.push("<p>");
      inPara = true;
    } else {
      html.push(" ");
    }
    html.push(inline(line));
  }
  closeList();
  closePara();
  return html.join("");
}
